import { configureStore, history } from "@/infrastructure/store";
import App from "@/modules/App";

import "antd/dist/antd.min.css";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { ConnectedRouter } from 'connected-react-router'
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import * as serviceWorker from "./serviceWorker";

document.title = `React Backtesting`;

const {store, rrfProps } = configureStore()

ReactDOM.render(
  <Provider store={store}>
    <ReactReduxFirebaseProvider {...rrfProps}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
    </ReactReduxFirebaseProvider>
  </Provider>,
  document.getElementById("root")
);

serviceWorker.unregister();
